"use client";

import { useLenis } from "lenis/react";
import { useCallback } from "react";

/** Same behavior as the fixed “back to top” control: Lenis when available, else `window.scrollTo`. */
export function useScrollToTop() {
  const lenis = useLenis();

  return useCallback(() => {
    const instant =
      typeof window !== "undefined" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (lenis) {
      lenis.scrollTo(0, { immediate: instant });
      return;
    }

    window.scrollTo({ top: 0, behavior: instant ? "auto" : "smooth" });
  }, [lenis]);
}
